export default (id: string) => {
    return '/api/objects/photo/' + id + '/image/1000/';
};
